import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { FiStar, FiShoppingCart, FiHeart, FiArrowLeft, FiTruck, FiRefreshCw, FiShield } from "react-icons/fi";
import { useProducts } from "../context/ProductContext";
import { useCart } from "../context/CartContext";
import ProductCard from "../components/ProductCard";
import "./ProductDetail.css";

export default function ProductDetail() {
  const { id } = useParams();
  const { products, loading } = useProducts();
  const product = products.find(p => p.id === +id);
  const { dispatch } = useCart();
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);

  useEffect(() => {
    if (product) {
      setSelectedSize(product.sizes?.[0] || "");
      setSelectedColor(product.colors?.[0] || "");
    }
  }, [product]);

  if (loading) return <div className="not-found">Loading...</div>;
  if (!product) return <div className="not-found">Product not found. <Link to="/shop">Back to Shop</Link></div>;

  const related = products.filter(p => p.category === product.category && p.id !== +id).slice(0, 4);
  const discount = product.originalPrice ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100) : null;

  const handleAdd = () => {
    for (let i = 0; i < qty; i++) dispatch({ type: "ADD", item: { ...product, size: selectedSize, color: selectedColor } });
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div className="product-detail-page">
      <Link to="/shop" className="back-link"><FiArrowLeft /> Back to Shop</Link>
      <div className="product-detail">
        <div className="detail-image">
          <img src={product.image} alt={product.name} />
          {product.badge && <span className={`badge badge-${product.badge.toLowerCase()}`}>{product.badge}</span>}
          {discount && <span className="badge badge-discount">-{discount}%</span>}
        </div>
        <div className="detail-info">
          <p className="detail-category">{product.category.toUpperCase()}</p>
          <h1>{product.name}</h1>
          <div className="detail-rating">
            {[...Array(5)].map((_, i) => <FiStar key={i} className={i < Math.floor(product.rating) ? "star filled" : "star"} />)}
            <span>{product.rating}</span>
            <span className="reviews">({product.reviews} reviews)</span>
          </div>
          <div className="detail-price">
            <span className="price">Rs. {product.price?.toLocaleString()}</span>
            {product.originalPrice && <><span className="original">Rs. {product.originalPrice?.toLocaleString()}</span><span className="save">Save {discount}%</span></>}
          </div>
          <p className="detail-desc">{product.description || `Premium quality ${product.name.toLowerCase()} crafted with care.`}</p>

          <div className="detail-option">
            <label>Color: <strong>{selectedColor}</strong></label>
            <div className="option-btns">
              {product.colors.map(c => <button key={c} className={selectedColor === c ? "active" : ""} onClick={() => setSelectedColor(c)}>{c}</button>)}
            </div>
          </div>
          <div className="detail-option">
            <label>Size: <strong>{selectedSize}</strong></label>
            <div className="option-btns">
              {product.sizes.map(s => <button key={s} className={selectedSize === s ? "active" : ""} onClick={() => setSelectedSize(s)}>{s}</button>)}
            </div>
          </div>
          <div className="detail-qty">
            <label>Quantity:</label>
            <div className="qty-control">
              <button onClick={() => setQty(q => Math.max(1, q - 1))}>−</button>
              <span>{qty}</span>
              <button onClick={() => setQty(q => q + 1)}>+</button>
            </div>
          </div>
          <div className="detail-actions">
            <button className={`add-btn ${added ? "added" : ""}`} onClick={handleAdd}>
              <FiShoppingCart /> {added ? "Added to Cart!" : "Add to Cart"}
            </button>
            <button className="wish-btn-lg"><FiHeart /></button>
          </div>
          <div className="detail-features">
            <div><FiTruck /> Free shipping </div>
            <div><FiRefreshCw /> 30-day easy returns</div>
            <div><FiShield /> Secure checkout</div>
          </div>
        </div>
      </div>
      {related.length > 0 && (
        <section className="related-section">
          <h2>You May Also Like</h2>
          <div className="related-grid">
            {related.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        </section>
      )}
    </div>
  );
}
